import ManagerRegisterContainer from './ManagerRegisterContainer';
export default ManagerRegisterContainer;
